import React from 'react';
import Img from 'gatsby-image';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { media } from '../../../utils/media-queries';
import RichText from '../../molecules/richtext';

const EntryImageCopy = ({ imageSrc, alt, copy }) => (
  <StyledEntryImageCopy className="grid">
    {imageSrc && <Img className="img" fluid={imageSrc} alt={alt} />}
    <div className="copy">
      <RichText blocks={copy} />
    </div>
  </StyledEntryImageCopy>
);

const StyledEntryImageCopy = styled.section`
  margin-bottom: var(--v-spacing-L);

  .copy {
    color: var(--blue);

    p {
      padding-bottom: var(--spacing-XS);
    }
  }

  @media ${media.L} {
    .img {
      grid-column: 1 / 14;
    }

    .copy {
      grid-column: 14 / 22;
    }
  }
`;

EntryImageCopy.propTypes = {
  imageSrc: PropTypes.object,
  alt: PropTypes.string,
  copy: PropTypes.array,
};

export default EntryImageCopy;
